import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loadingState: false,
    axiosList: [],
    userInfo : {}
  },
  mutations: {
    setUserInfo(state,data) {
      state.userInfo = data
    },
    updateLoadingState(state, data) {

      if(data.state) {
        state.axiosList.push(data.axios)
        state.loadingState = true
      } else {
        const res = state.axiosList.find(axios => {
          if(axios.$$state === 'pendding') {
            return true
          }
        })
        if(!res) {
          state.axiosList = []
          state.loadingState = false
        }
      }
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js